import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { dark } = theme.palette.secondary;

  return {
    addHorseButton: {
      marginLeft: 16,
      color: dark,
      fontSize: 14,
      textTransform: "capitalize",
      paddingTop: 0,
      paddingBottom: 0,
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        marginLeft: 12
      },
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        marginLeft: 8
      }
    }
  };
});
